import type { TFunction } from 'i18next'
import {
  DROPDOWN_ORGAN_TYPE,
  DROPDOWN_BRAZIL_STATES,
  VERTICAIS_OPTIONS,
  MARCO_LEGAL_OPTIONS,
  OBJETIVOS_OPTIONS
} from 'domain/feature/hotsite/Forms/NewPublicOrganRegister/constants'

export const publicAdministrationOrganTypeOptions = DROPDOWN_ORGAN_TYPE.filter(o => o.value !== '')

export const publicAdministrationBrazilStateOptions = DROPDOWN_BRAZIL_STATES.filter(o => o.value !== '')

export const publicAdministrationPopulationSizeOptions = (
  trans: TFunction
): Array<{ id: number; label: string }> => [
  {
    id: 0,
    label: trans('ecosystem.publicAdministration.filter.population.0', {
      defaultValue: 'Pequeno porte (até 50.000 hab.)'
    })
  },
  {
    id: 1,
    label: trans('ecosystem.publicAdministration.filter.population.1', {
      defaultValue: 'Médio porte (50.001 a 100.000 hab.)'
    })
  },
  {
    id: 2,
    label: trans('ecosystem.publicAdministration.filter.population.2', {
      defaultValue: 'Grande porte (100.001 a 900.000 hab.)'
    })
  },
  {
    id: 3,
    label: trans('ecosystem.publicAdministration.filter.population.3', {
      defaultValue: 'Metrópole (acima de 900.000 hab.)'
    })
  }
]

export const publicAdministrationBooleanFilterOptions = (
  trans: TFunction
): Array<{ value: string; label: string }> => [
  {
    value: 'true',
    label: trans('ecosystem.publicAdministration.filter.boolean.yes', { defaultValue: 'Sim' })
  },
  {
    value: 'false',
    label: trans('ecosystem.publicAdministration.filter.boolean.no', { defaultValue: 'Não' })
  }
]

export { VERTICAIS_OPTIONS, MARCO_LEGAL_OPTIONS, OBJETIVOS_OPTIONS }
